"use client";
import { useEffect } from 'react';

const useArms = () => {
  const init = async () => {
    const initArms = (await import('../utils/arms')).default;
    initArms();
  };

  useEffect(() => {
    init();
  }, []);
};

export default useArms;
